const swiper = new Swiper(".swiper", {
//   loop: true,
  slidesPerView: 2,
  spaceBetween: 15,
  parallax: true,
  // centeredSlides: true,
  lazy: true, // Lazy Loadを有効にする
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  breakpoints: {
    // 画面幅が767px以下の場合
    768: {
      slidesPerView: 4,
  	  
      centeredSlides: false, // スライドを中央に配置
      spaceBetween: 30,
    }
  }
});
// var slideItems = document.querySelector('.slide-wrapper');
// topStyle.on('slideChange',function(){
// 	console.log(topStyle.realIndex);
// 	var move = -400*(topStyle.realIndex);
// 	slideItems.style.transform = 'translate('+ move +'px,0)';
// })

const swiper02 = new Swiper(".swiper02", {
//   loop: true,
  slidesPerView: 1.2,
  spaceBetween: 30,
  centeredSlides: true,
  lazy: true, // Lazy Loadを有効にする
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  breakpoints: {
    // 画面幅が767px以下の場合
    768: {
      slidesPerView: 3,
      centeredSlides: false, // スライドを中央に配置
      spaceBetween: 30,
    },
    499: {
      slidesPerView: 2,
      centeredSlides: false, // スライドを中央に配置
      spaceBetween: 30,
    }

  }
});

const swiper03 = new Swiper(".swiper03", {
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween: 20,
//   loop: true,
  
  lazy: true, // Lazy Loadを有効にする
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  breakpoints: {
    // 画面幅が767px以下の場合
    499: {
      slidesPerView: 2,
      centeredSlides: false, // スライドを中央に配置
      spaceBetween: 30,
    }
  }
});


//要素が画面幅を超えたらswiperのクラス名を付与する処理
const slideWrapper = document.querySelectorAll(".slide-wrapper");
slideWrapper.forEach((el) => {
  if (el.clientWidth > document.body.clientWidth) {
    el.classList.add("swiper-wrapper");
    const children = el.children; //.slide-wrapperの子要素
    const parent = el.parentNode; //.slide-wrapperの親要素

    for (var i = 0, len = children.length; i < len; i++) {
      // 子要素全てにclassを付与
      children[i].classList.add("swiper-slide");
    }
    // 親要素全てにclassを付与
    parent.classList.add("swiper");
  }
});


  // swiper04の初期化
  const swiper04 = new Swiper(".swiper04", {
    preloadImages: false,
  lazy: {
    loadPrevNext: true,
  },
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1500,
    on: {
      slideChange: function () {
        const prevSlide = this.slides[this.previousIndex];
        prevSlide.querySelector('.main-view__image img').classList.remove('zoomed');

        const currentSlide = this.slides[this.activeIndex];
        currentSlide.querySelector('.main-view__image img').classList.add('zoomed');
      },
    },
  });

  const swiperLp = new Swiper(".swiper-lp", {
    loop: true,
    slidesPerView: 3,
    speed: 6000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
  });


    var leftSwiper = new Swiper('.swiper-left', {
      loop: true,
      slidesPerView: 3,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
    });
    var leftSwiperV2 = new Swiper('.swiper-left_v2', {
        loop: true,
        slidesPerView: 2.01,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
        },
    });
    var rightSwiper = new Swiper('.swiper-right', {
        loop: true,
        slidesPerView: 3,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            reverseDirection: true
        },
    });
    var rightSwiperV2 = new Swiper('.swiper-right_v2', {
        loop: true,
        slidesPerView: 2.01,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            reverseDirection: true
        },
    });
